import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "./index.scss";
import "./assets/fonts/fonts.css";

import reportWebVitals from "./reportWebVitals";
import App from "./screens/app/App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
